import React, { useState } from 'react';
import { cn } from '../../utils/cn';

const RegionSelector = ({ className }) => {
  const [current, setCurrent] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('neevii-website-region') || 'uk';
    }
    return 'uk';
  });

  const onChange = (e) => {
    const v = e.target.value;
    localStorage.setItem('neevii-website-region', v);
    setCurrent(v);
  };

  return (
    <div className={cn('flex items-center gap-3', className)}>
      <label htmlFor="region-select" className="text-sm text-slate-700">Region</label>
      <select
        id="region-select"
        className="h-10 rounded-md border border-[#808a9d] bg-[#a3b1cf] text-slate-900 px-3 py-2 text-sm font-semibold uppercase tracking-wide transition-colors hover:bg-[#94a3c0] focus:outline-none focus:ring-2 focus:ring-[#808a9d]"
        value={current}
        onChange={onChange}
      >
        <option value="uk">UK</option>
        <option value="intl">International</option>
      </select>
    </div>
  );
};

export default RegionSelector;
